import { LoadingButton } from "@mui/lab";
import { Alert, Grid, TextField } from "@mui/material";
import SimpleBarScroll from "components/SimpleBar";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productRemovalThunk } from "store/reducers/refill/refillSlice";
import * as yup from "yup";

const RemoveForm = ({ tray_id, partition, fullGrid }) => {
  const dispatch = useDispatch();
  const { loading, error, errorMessage, success } = useSelector(
    (state) => state.refill
  );
  const validation = yup.object({
    qty: yup
      .number()
      .required("Enter qty")
      .positive()
      .min(1)
      .max(partition.current_count),
  });

  const formik = useFormik({
    initialValues: {
      partition: partition.id,
      qty: partition.current_count,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log(data);
      dispatch(productRemovalThunk({ tray: tray_id, data }));
    },
    validateOnChange: false,
  });
  useEffect(() => {
    if (errorMessage?.remove_product) {
      Object.keys(errorMessage?.remove_product).forEach((key) => {
        console.log(key, errorMessage?.remove_product[key][0]);
        formik.setFieldError(key, errorMessage?.remove_product[key][0]);
      });
    }
  }, [errorMessage]);
  return (
    <>
      <SimpleBarScroll>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1.5} paddingY={1}>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <TextField
                label={`Qty (max ${partition.current_count})`}
                variant="outlined"
                name="qty"
                fullWidth
                value={formik.values.qty}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.qty)}
                helperText={formik.errors.qty}
                autoComplete="new-password"
                type="number"
                required
              />
            </Grid>
          </Grid>
          {error?.remove_product && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred
            </Alert>
          )}

          {success?.remove_product && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            loading={loading?.remove_product}
            variant="contained"
            type="submit"
            sx={{ paddingX: 10, marginTop: 1 }}
          >
            Remove product
          </LoadingButton>
        </form>
      </SimpleBarScroll>
    </>
  );
};

export default RemoveForm;
